<template>
  <div>
    <v-dialog
      v-model="orderCaseFileModal"
      persistent
      max-width="800px"
    >
      <v-card>
        <v-card-title class="pb-0">
          <v-flex
            xs11
            sm10
            md10
          >
            <span class="headline">
              Order Case Images
            </span>
          </v-flex>
          <v-flex
            xs1
            sm2
            md2
          >
            <v-btn
              flat
              @click="closeDialog()"
              class="close"
            >
              <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span>
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-flex
            xs12
            class="pb-3 px-2"
            style="font-size: 1.6rem"
          >
            <b>Case ID: </b> {{ formData.order_case_id }}
          </v-flex>

          <order-images
            v-if="formData.order_case_id"
            :formData="formData"
            url="api/order-case-file"
            singleStoreUrl="api/order-case-file/single-store"
            filenameKey="file_name"
            modelFk="order_case_id_fk"
            modelPk="order_case_id"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="height:auto"
            @click="closeDialog()"
            outline
            color="normal"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: {
    orderCaseFileModal: { type: Boolean, default: false },
    formData: { type: Object, default: () => { } },
    isUpdate: { type: Boolean, default: false },
    fromCustomer: { type: Boolean, default: false }
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      let url = 'api/order-case'
      if (this.fromCustomer) {
        url = 'api/order-case/customer-store'
      }

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            Axios.put(`${url}/${this.formData.order_case_id}`, this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: 'Updated',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch(error => {
                swal('Error', `${error.response.data.message}`, 'error')
              })
          } else {
            Axios.post(url, this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: 'Added',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch(error => {
                swal('Error', `${error.response.data.message}`, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/orderCase/orderCaseFiles.vue